const getImageUrl = (image) => {
  return 'https://s3nimax.nimax.ru' + image;
};
export default getImageUrl;
